import React from 'react';
import PropTypes from 'prop-types';
import { dateFormat } from '~/components/AgentScanners/types/commonTypes';
import LoadingElement from '~/components/Layout/LoadingElement';
import FormattedDate from '~/components/Layout/FormattedDate';
import Overview from './Overview';
import Review from './Review';
import styles from './ScanAuditLog.css';

const ScanAuditLog = ({ scanner, showLoading }) => {
  return (
    <div id="scanAuditLogPage" data-test-id="scanner-audit-log-page">
      {/* Page Header */}
      <div className={styles.pageHeader}>
        <div className={styles.breadcrumbs}>
          <button
            type="button"
            className={styles.breadcrumbLink}
            onClick={() => {}}
            data-test-id="back-to-list"
          >
            Agent scanners
          </button>
          <span className={styles.breadcrumbSeparator}>›</span>
          <button
            type="button"
            className={styles.breadcrumbLink}
            onClick={() => {}}
            data-test-id="back-to-detail"
          >
            {scanner.name}
          </button>
          <span className={styles.breadcrumbSeparator}>›</span>
          <span
            className={styles.breadcrumbCurrent}
            data-test-id="scanner-name-breadcrumb"
          >
            {showLoading ? 'Scan in Progress...' : 'Scan audit log'}
          </span>
        </div>
        <div className={styles.detailHeader}>
          <div className={styles.detailTitleSection}>
            <h1
              className={styles.detailTitle}
              data-test-id="scanner-name-heading"
            >
              Scan audit log
              <span>
                <span> - </span>
                <FormattedDate
                  testId="scan-config-last-run"
                  date={new Date()}
                  format={dateFormat}
                  display-if={!showLoading}
                />
              </span>
            </h1>
          </div>
        </div>
      </div>

      <LoadingElement message="Scan in Progress..." display-if={showLoading} />

      <div className={styles.detailContent} display-if={!showLoading}>
        <Overview scanner={scanner} />

        <Review />
      </div>
    </div>
  );
};

ScanAuditLog.propTypes = {
  scanner: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    connectionName: PropTypes.string.isRequired,
    status: PropTypes.oneOf(['SUCCESS', 'CLOSE', 'Running', 'Idle', 'Error'])
      .isRequired
  }),
  showLoading: PropTypes.bool
};

export default ScanAuditLog;
